"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ResourceList_1 = __importDefault(require("../ResourceList"));
const City_1 = __importDefault(require("../models/City"));
class Cities {
    constructor(client) {
        this.client = client;
    }
    fromId(cityId) {
        return new City_1.default(this.client, { city_id: cityId });
    }
    async list(params = {}) {
        const url = encodeURI('/cities');
        const result = await this.client.get(url, { search: params.query, cursor: params.cursor });
        const { data: { data: cities, cursor } } = result;
        const data = cities.map((city) => new City_1.default(this.client, city));
        return new ResourceList_1.default(data, this.list.bind(this), cursor);
    }
}
exports.default = Cities;
//# sourceMappingURL=Cities.js.map